export const basename = '/report-it';
